// AddDatabaseModalCreateFlow.jsx

import React from 'react';

// Hooks
import { CREATE_TAB_ABOUT, CREATE_TAB_FIELDS } from './useAddDatabaseModalState';

// CSS
import './AddDatabaseModalCreateFlow.css';

// Components
import CreateTypeSection from 'components/addmodal/sections/createtype/CreateTypeSection';
import ModalHint from 'components/modal/hint/ModalHint';
import Tabs from 'components/tabs/Tabs';
import TypeFields from 'collection/typefields/TypeFields';

/**
 * AddDatabaseModalCreateFlow
 *
 * Renders the create-database tabs for metadata editing and field setup.
 *
 * @param {object} flowState - Modal flow state used to determine the active tab and copy.
 * @param {object} createTypeState - Create-type form state and handlers.
 * @param {string|null} baseKey - Active space key.
 *
 * @returns {ReactNode} The rendered create flow.
 */
const AddDatabaseModalCreateFlow = ({
    flowState,
    createTypeState,
    baseKey,
}) => {

        // ----- RENDER ----- //

        return (
        <>
            <Tabs
              tabs={flowState.createTabs}
              selectedKey={flowState.selectedCreateTab}
            />

            {/* PANEL */}
            {flowState.selectedCreateTab === CREATE_TAB_ABOUT && (
                <div className="add-database-modal-panel">
                    <CreateTypeSection
                      iconKey={createTypeState.iconKey}
                      setIconKey={createTypeState.setIconKey}
                      isSavingType={createTypeState.isSavingType || createTypeState.isUpdatingType}
                      canSaveType={flowState.hasCreatedType ? createTypeState.canSaveCreatedType : createTypeState.canSaveType}
                      label={createTypeState.label}
                      setLabel={createTypeState.setLabel}
                      labelHelperText={createTypeState.labelHelperText}
                      labelPlural={createTypeState.labelPlural}
                      pluralHelperText={createTypeState.pluralHelperText}
                      description={createTypeState.description}
                      setDescription={createTypeState.setDescription}
                      defaultView={createTypeState.defaultView}
                      setDefaultView={createTypeState.setDefaultView}
                      showSubmitButton={false}
                      onCreateType={flowState.hasCreatedType ? createTypeState.handleSaveCreatedType : createTypeState.handleCreateType}
                      onLabelBlur={createTypeState.handleLabelBlur}
                      onLabelPluralBlur={createTypeState.handleLabelPluralBlur}
                      onLabelPluralChange={createTypeState.handleLabelPluralChange}
                    />
                </div>
            )}

            {flowState.selectedCreateTab === CREATE_TAB_FIELDS && (
                <div className="add-database-modal-fields">
                    <ModalHint
                      iconKey="info"
                      title={`Your collection is ready. What fields would be useful for each ${flowState.createdTypeLabelLower} in this collection?`}
                    />

                    {/* FIELDS CONTENT */}
                    <div className="add-database-modal-fields-content">
                        <TypeFields
                          typeKey={createTypeState.newTypeKey}
                          baseKey={baseKey}
                        />
                    </div>
                </div>
            )}
        </>
    );
};

// Dev Tools
AddDatabaseModalCreateFlow.displayName = 'AddDatabaseModalCreateFlow';

export default AddDatabaseModalCreateFlow;
